import { Injectable } from '@angular/core';
import {
  ProductCardConfiguration,
  ProductCardConfigurationKeys,
  PRODUCT_CARD_FEATURE_NAME,
} from '@epicuro-next/constants/rule-engine/product-card-rules';
import { MerchandiseService } from '@epicuro-next/data/merchandise';
import { selectConfigurationValueFrom } from '@epicuro-next/platform/configuration';
import {
  selectAccountId,
  selectSiteId,
} from '@epicuro-next/state/session-state';
import { isNonNullish } from '@epicuro-next/utilities';
import { createEffect } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

import { loadMarketingProductsSuccess } from '../../actions';

@Injectable()
export class MerchandiseMarketingEffects {
  public showMarketingLabel$ = this.store.pipe(
    select(
      selectConfigurationValueFrom<
        ProductCardConfigurationKeys.ShowMarketingLabel,
        ProductCardConfiguration
      >(
        PRODUCT_CARD_FEATURE_NAME,
        ProductCardConfigurationKeys.ShowMarketingLabel,
        false,
      ),
    ),
  );

  constructor(
    private store: Store,
    private merchandiseService: MerchandiseService,
  ) {}

  public loadMerchandiseMarketingProductIds$ = createEffect(() =>
    combineLatest([
      this.store.pipe(select(selectAccountId), filter(isNonNullish)),
      this.store.pipe(select(selectSiteId), filter(isNonNullish)),
      this.showMarketingLabel$.pipe(filter(isNonNullish)),
    ]).pipe(
      filter(([, , showMarketingLabel]) => showMarketingLabel),
      switchMap(([accountId, siteId]) =>
        this.merchandiseService
          .getMarketingProducts(accountId, siteId)
          .pipe(map((products) => loadMarketingProductsSuccess({ products }))),
      ),
    ),
  );
}
